export const IS_LOGIN = "IS_LOGIN";
export const IS_LOGOUT = "IS_LOGOUT";
export const VERIFY_TOKEN = "VERIFY_TOKEN"
export const PROFILE_DETAIL = "PROFILE_DETAIL"
export const PROFILE_DETAIL_LOADER = "PROFILE_DETAIL_LOADER"
export const DESTROY_SESSION = "DESTROY_SESSION";
export const USER_LIST = "USER_LIST"
export const USER_LIST_LOADER = "USER_LIST_LOADER"
export const CATEGORY_LIST = "CATEGORY_LIST"
export const CATEGORY_LIST_LOADER = "CATEGORY_LIST_LOADER"
export const CATEGORY_BYID_LIST = "CATEGORY_BYID_LIST"
export const STORE_LIST = "STORE_LIST"
export const STORE_LIST_LOADER = "STORE_LIST_LOADER"
export const STORE_BYID_LIST = "STORE_BYID_LIST"
export const DASHBOARD_DETAILS = "DASHBOARD_DETAILS"
export const DASHBOARD_DETAILS_LOADER = "DASHBOARD_DETAILS_LOADER"
export const NOTIFICATION_DETAILS = "NOTIFICATION_DETAILS"
export const NOTIFICATION_DETAILS_LOADER = "NOTIFICATION_DETAILS_LOADER"
export const CHAT_USER_LIST = "CHAT_USER_LIST"
export const CHAT_USER_LIST_LOADER = "CHAT_USER_LIST_LOADER"
export const CHAT_SINGLE_USER_LIST = "CHAT_SINGLE_USER_LIST"
export const CHAT_SINGLE_USER_LIST_LOADER = "CHAT_SINGLE_USER_LIST_LOADER"
export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const BANNER_LIST = "BANNER_LIST";
export const BANNER_LIST_LOADER = "BANNER_LIST_LOADER";
export const BANNER_BYID_LIST = "BANNER_BYID_LIST";
export const PROMOTIONAL_BANNER_LIST = "PROMOTIONAL_BANNER_LIST";
export const PROMOTIONAL_BANNER_LIST_LOADER = "PROMOTIONAL_BANNER_LIST_LOADER";
